<div class="status-view flex flex-col justify-between h-full">
	<app-modal-alert
		*ngIf="openAlert"
		[value]="valueModalDelete"
		[nameModal]="'modalAlertDeleteElement'"
		[elementsDelete]="elementsDelete"
		(closeModalAlert)="closeModalAlert($event)"
	></app-modal-alert>
	<div class="status-view w-full h-full">
		<app-loading-spinner *ngIf="loading"></app-loading-spinner>

		<div
			class="flex flex-wrap gap-[24px] px-12 pt-12 overflow-y-auto w-full h-[calc(100vh-360px)]"
			*ngIf="group.statusUser.length && !loading"
		>
			<div
				class="grid-custom my-4 mr-4 lg:my-4 flex h-44"
				*ngFor="let statuRole of status; let i = index"
			>
				<div class="card w-60 max-w-[calc(400px)]">
					<div class="max-w-lg mr-auto ml-0 md:max-w-xs">
						<div class="settings flex justify-end pb-2 relative">
							<mat-icon
								class="icon-settings text-primary-color text-sm cursor-pointer"
								(click)="menu.toggle($event)"
							>
								settings
							</mat-icon>
							<p-menu #menu [popup]="true" [model]="statuRole.items"></p-menu>
						</div>
						<div class="w-full justify-between flex" [title]="statuRole.name">
							<span class="nameRole"> {{ statuRole.name }}</span>
							<div
								class="colorStatus"
								[ngStyle]="{
									'background-color': statuRole.color || '#FEF7B6'
								}"
							></div>
						</div>
						<div class="flex w-full justify-between pt-5 pb-8">
							<div class="mr-3 justify-center flex items-center">
								<img width="45px" [src]="statuRole.image" alt="" />
							</div>
							<div class="justify-center flex items-center">
								<span class="numberRole">{{ statuRole.roles.length }}</span>
							</div>
							<div class="ml-3 justify-center flex flex-col items-center">
								<span class="textSubGroups"
									>Total<br />
									Roles</span
								>
							</div>
						</div>
					</div>
				</div>
				<!--
				<app-vertical-line
					class="hidden md:block ml-4 vertical-line"
					*ngIf="(i + 1) % numberOfColums !== 0 && i !== status.length - 1"
				></app-vertical-line> -->
			</div>
		</div>
	</div>
	<div class="buttons w-full flex items-center justify-end h-16 pr-4">
		<button class="mg-button px-3" (click)="openDialogNewStatus()">
			<mat-icon class="text-primary-color mr-2"> add </mat-icon>
			<span class="font-lato"> {{ translateStatus.buttonNew }} </span>
		</button>
	</div>
</div>
